import React, { memo } from "react";
import TextField from "@mui/material/TextField";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import PleaseNote from "../PleaseNote";
import Grow from "@mui/material/Grow";
import { Image, Transformation } from "cloudinary-react";
import { cladColor } from "./defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useExtCladSelector from "./useExtCladSelector";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

function ExteriorCladAccordian() {
  const {
    handleChange,
    customCladColor,
    handleClick,
    customCladChosen,
    variant,
    checkMark,
    cladColorImg,
    cladColorOptions,
  } = useExtCladSelector();
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <ReusableAccordian
      accordionName="exteriorClad"
      heading="Exterior Clad Color"
      secondaryHeading="Select exterior clad color"
      colOrRow="col"
    >
      {customCladChosen && (
        <PleaseNote
          notes={[
            "A shade variation in custom clad color is expected in production line spraying.",
            "Please send color sample to our office with your quote number included. Production will not start until sample is recieved. Send to: 3111 Golf Course Dr. Ventura, CA 91301",
          ]}
        />
      )}

      <ColLayout>
        {!customCladChosen && (
          <PleaseNote
            notes={[
              "Colors on screen may vary from end product",
              "AAMA 2605 standard",
            ]}
          />
        )}
        <RowLayout>
          {cladColorOptions.map((state) => (
            <div key={state.id} onClick={() => handleClick(state.label)}>
              <Choices
                label={state.label}
                variant={variant(state.label)}
                checkMark={checkMark(state.label)}
                disabled={readOnly}
              />
            </div>
          ))}
        </RowLayout>
      </ColLayout>
      {customCladChosen ? (
        <TextField
          error={customCladChosen && !customCladColor ? true : false}
          helperText={
            !customCladColor ? "Please Enter a Custom Clad Color" : ""
          }
          variant="outlined"
          margin="dense"
          onChange={handleChange}
          value={customCladColor}
          disabled={readOnly}
        />
      ) : cladColorImg ? (
        <RowLayout>
          <Grow in={true}>
            <div>
              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId={cladColorImg.imgLabel}
              >
                <Transformation
                  width="200"
                  height="200"
                  radius="35"
                  crop="scale"
                />
              </Image>
            </div>
          </Grow>
        </RowLayout>
      ) : null}
    </ReusableAccordian>
  );
}

export default memo(ExteriorCladAccordian);
